export default (phones: string) => {
  if (!phones) {
    return [];
  }

  return phones.split(';').map(phone => phone.trim());
};
